/* eslint-disable formatjs/enforce-id */
import { ReactElement } from 'react';
import { Column, Grid, Row, Button, ButtonSet } from 'carbon-components-react';
import { FormattedMessage } from 'react-intl';
import { segmentTracking } from '../lib/tracker';
import messages from '../locales/messages';
import 'src/common/style/common.scss';

export interface thanksProps {
  timePerYear: number;
  ansibleTask: number;
  ansibleTaskDev: number;
  ansibleDeveloper: number;
  licensePrice: string;
  bpName: string;
  bpConsentMail: boolean;
}

const Thanks = ({
  timePerYear,
  ansibleTask,
  ansibleTaskDev,
  ansibleDeveloper,
  licensePrice,
  bpName,
  bpConsentMail,
}: thanksProps): ReactElement => {
  return (
    <Grid id="ThankYou">
      <Row>
        <Column sm={4} md={16} lg={16}>
          <div className="bx--row padding-row">
            <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
              <div className="thanks__pad1 page_heading">
                <FormattedMessage id="aYIUar" defaultMessage="Thank you!" />
              </div>
              <div className="page_sub_heading">
                <FormattedMessage
                  id="PwjLGb"
                  defaultMessage="We have received your request"
                />
              </div>
              <div className="page_sub_heading_2 thanks__pad2">
                <FormattedMessage
                  id="0L49M8"
                  defaultMessage="Request details:"
                />
              </div>
              <div className="thanks__requirement thanks__pad4">
                <FormattedMessage {...messages.labeltext_ansibleDeveloper} />:{' '}
                <strong>{ansibleDeveloper}</strong>
                <br />
                <FormattedMessage {...messages.labeltext_ansibleTask} />:{' '}
                <strong>{ansibleTaskDev}</strong>
                <br />
                <FormattedMessage {...messages.ansible_task_title} />:{' '}
                <strong>{ansibleTask}</strong>
                <br />
                <FormattedMessage {...messages.explorer_title} />:{' '}
                <strong>{`${timePerYear} `}</strong>
                <br />
                <FormattedMessage {...messages.estimated_price} />:{' '}
                <strong>{`${licensePrice} `}</strong>
                <br />
                {bpName && (
                  <>
                    <FormattedMessage
                      id="rzX/AG"
                      defaultMessage="Selected Business Partner: "
                    />
                    <strong>{bpName}</strong>
                    <br />
                    <FormattedMessage
                      id="9k14Pe"
                      defaultMessage="I consent to IBM providing my business contact information: "
                    />
                    <strong>
                      <FormattedMessage
                        id={`widget.${bpConsentMail ? 'yes' : 'no'}`}
                        defaultMessage={bpConsentMail ? 'Yes' : 'No'}
                      />
                    </strong>
                    <br />
                  </>
                )}
              </div>
              <ButtonSet
                className="watsonx_code_assistant__stack-button thanks__pad3"
                stacked
              >
                <Button
                  style={{ minWidth: '180px' }}
                  onClick={() => {
                    segmentTracking('CTA Clicked', {
                      pageTitle: 'watsonx Code Assisntant Price Estimator',
                      object: 'Pricing page',
                      resultValue: 'CTA clicked',
                      CTA: 'Return to Estimator',
                      location: 'Thankyou',
                      action: '',
                      field: '',
                    });
                    window.location.reload();
                  }}
                >
                  <FormattedMessage {...messages.return_to_estimator} />
                </Button>
              </ButtonSet>
            </div>
          </div>
        </Column>
      </Row>
    </Grid>
  );
};

export default Thanks;
